import { useEffect } from "react";
import { withNamespaces } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";

// Antd Components
import { fetchRolesUsers } from "@/store/actions";
import "react-simple-keyboard/build/css/index.css";
import { Card, Spin } from "antd";
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const SwitchUserPin = ({ t, setNewUser }) => {
  const dispatch = useDispatch();
  const currnetUserId = useSelector((state) => state.auth.user_role_id);

  const users = useSelector((state) => state.rolesAndUsers.users);
  const fetchingUsers = useSelector((state) => state.rolesAndUsers.loading);

  const config = useSelector((state) => state.config);

  useEffect(() => {
    if (!users.length) {
      dispatch(fetchRolesUsers());
    }
  }, []);

  if (fetchingUsers) {
    return (
      <div className="mt-4 text-center">
        <Spin indicator={antIcon} />
      </div>
    );
  }
  const switchableUsers = users.filter(
    (u) => u.has_pin_code && u.id !== currnetUserId
  );

  return (
    <div
      className="d-flex text-center "
      style={{
        gap: 10,
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      {switchableUsers.map((user) => (
        <Card
          hoverable
          style={{ flex: "50%" }}
          onClick={() => {
            setNewUser(user);
          }}
        >
          <div>
            <h4>{user.name || user.username}</h4>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default withNamespaces()(SwitchUserPin);
